// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2021-05-20T09:53:17+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  126236
//    Project:        188
//    Environment:    377 - master
//    MD5:            d6cc363ef109e5d8b68d36ac784f943d
//    Signature:      eyJpdiI6Ijl4VnhRMUpjWmZ5bFVlU0IyZHd6MFE9PSIsInZhbHVlIjoiT2JEandEQXQzejhVKzljdzFzajNoZDNpYUY5VjlVMTR1VWdIMVwvNjlmTDQ3dWRsSTY1YWNoODFVaFpMaGRHTGZRUEdcLzhYcUorTFpcL3U3c3FWMXgzNHQ0YVwvM2ROTzEyYlZ1MVhFS2tmV2xnUjhYWkw5amxtVTVHMXBudGhDOU5Kd01FVzBNXC83ZTBsaFU5WWZWU1NTcE1ERlVrWXpzU09cL2cyZ0ZEQnZIRmN3MkVkMkZWNHNPNEdXeURNT3BhXC92NWpUK1lrQ01BYTdrcnhkNSswTlFGS0hnNXkzc3Vucnd5bkFSV1pZNVpUNDdOQXVoVnlZajNETDBcL3huNE9pUW1uZmlBMEZCT3lwbkRjQ3ZSXC9HYzNZQ1lZb3NYcVljVlB2a2lKXC83VHBEWFBRRmgxYlwvS25JK3k5U1hrd2hDZk1MZXVWYkRmY3pUa1BoMXhCbUNzUVlqcHR2R3pJYWlkY3hxMmtoMW55cXFyOGZ2cnl1SUJpT21SeVZiQ2R5SkhSaWVLWjREZjZiaURDTVJkcVgwSkFpOFBBPT0iLCJtYWMiOiJmZmI1ZjQ2YWE4MDEzZmY4NDA0YmVjN2E0ODYzZjE0NDNjZjdkNTYyODVkMzMyN2E0YTIwZDk4MjZhYzk2NmIxIn0=
// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2020-03-25T11:08:15+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  66174
//    Project:        188
//    Environment:    377 - master
//    MD5:            78695e0755da857435baae96799861f1
//    Signature:      eyJpdiI6IjY0UGV0R1FaRjF1dk9HR3d4SHhMbGc9PSIsInZhbHVlIjoic1g2WVhwdHZXVERjbGRlMVdvemdGb0MxZGErSzlwV1AxTWJNN2JcL2JqN1JvQUxPZHFFYWJ4Kyt0Tk9KWThYdGtrTGpNS1wvTFdFOTVTMkNxeWdUQnVUSWdRT1hxcVdmUEt2NWFBZEVSSXVRV1VoaWJQbmlwaFg0SjZGTFhBOURoaTRGMjFJaUdSZGsrM0VtTHNxOWtOcWRpY0thb1JZaksza1JTMW9IMWZ4K2w1NTY2eXNteVF1XC9lNmVpUkRvWjg2TTc3U0IzOFJBQU1JK285bDRqVXZTOXUwN0VDRVBHMlFHdnlONTdUTzlacU1KV1F3SmxhdFJneUpRRXptbklzSTdrcVFYeWRuYzNqQjlEWE9PU2NWNVFKXC9cL0NDTzNiZjFGajFJaW8zeU1lYmpjWXJlbFF2YXowOSs2WFJLYk5Wdkl6ME1vTFY5T3RFS2ZlZ3hoVDFVNGRhMDJYTUZhVjRiUlwvTnRiRHV2UTU5UXd2bWNRQXVnS0gxNDd3dUpKZDlYbmVkMHg2SEFObXp1c2p5OWFJemNIdz09IiwibWFjIjoiYjUxNGNlOTRiZjZiN2EzNmMzODkyMzVjNDc4NTBmNDE3NTBmNDJkZTI2ODg5ZDM0YTExNjA4NGU2NzAzYmY4MSJ9
/*!
 * JavaScript Cookie v2.2.0
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (typeof define === 'function' && define.amd) {
		define(factory);
		registeredInModuleLoader = true;
	}
	if (typeof exports === 'object') {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));
